export default {
  name: 'KDropdownMenu',
  provide() {
    return {
      onItemClick: this.handleItemClick,
      hasIcon: this.hasIcon,
    }
  },
  data() {
    return {
      itemHasIcon: false,
      visible: false,
      direction: 'bottom',
    }
  },
  computed: {},
  watch: {
    // visible() {
    // const items = getComponentsByName(this.$children, 'KDropdownItem')
    // console.log('open: ', this.visible, items)
    // this.visible ? this.doOpen(items) : this.doClose(items)
    // },
  },
  mounted() {
  },
  render() {
    const css = {
      'km-dropdown-menu': true,
      'km-dropdown-menu--has-icon': this.itemHasIcon,
    }

    return <div class={css}>{this.$slots.default}</div>
  },
  methods: {
    // doOpen(items) {
    //   // console.log('open: ', this.direction)
    //   // @TODO transition
    // },
    // doClose(items) {
    //   // @TODO transition
    // },
    handleItemClick(e, action, instance) {
      this.$emit('menu-item-click', e, action, instance)
    },
    hasIcon() {
      this.itemHasIcon = true
    },
  },
}
